var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataStructure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_87b2521e85d17565bb8c22cd8b014612",
    "data-name": "87b2521e85d17565bb8c22cd8b014612",
    transform: "translate(-1 -1.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 56,
    height: 23,
    rx: 3,
    transform: "translate(21 1.181)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 43,
    height: 23,
    rx: 3,
    transform: "translate(1 74.181)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 43,
    height: 23,
    rx: 3,
    transform: "translate(1 44.181)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 43,
    height: 23,
    rx: 3,
    transform: "translate(54 74.181)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 43,
    height: 23,
    rx: 3,
    transform: "translate(54 44.181)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M19.317,7.317H17.658a1.658,1.658,0,1,1,0-3.317h1.658a1.658,1.658,0,0,1,0,3.317Zm21.558,0H25.95A1.658,1.658,0,0,1,25.95,4H40.875a1.658,1.658,0,0,1,0,3.317Z",
    transform: "translate(9.874 1.975)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M7.317,51.317H5.658a1.658,1.658,0,1,1,0-3.317H7.317a1.658,1.658,0,1,1,0,3.317Zm21.558,0H13.95a1.658,1.658,0,1,1,0-3.317H28.874a1.658,1.658,0,1,1,0,3.317Z",
    transform: "translate(1.975 30.94)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M7.317,33.317H5.658a1.658,1.658,0,1,1,0-3.317H7.317a1.658,1.658,0,1,1,0,3.317Zm21.558,0H13.95a1.658,1.658,0,1,1,0-3.317H28.874a1.658,1.658,0,1,1,0,3.317Z",
    transform: "translate(1.975 19.091)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M39.317,51.317H37.658a1.658,1.658,0,1,1,0-3.317h1.658a1.658,1.658,0,1,1,0,3.317Zm21.558,0H45.95a1.658,1.658,0,1,1,0-3.317H60.874a1.658,1.658,0,1,1,0,3.317Z",
    transform: "translate(23.04 30.94)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M39.317,33.317H37.658a1.658,1.658,0,1,1,0-3.317h1.658a1.658,1.658,0,1,1,0,3.317Zm21.558,0H45.95a1.658,1.658,0,1,1,0-3.317H60.874a1.658,1.658,0,1,1,0,3.317Z",
    transform: "translate(23.04 19.091)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M69.382,29.925V34.9H66.066V29.925a1.658,1.658,0,0,0-1.658-1.658H17.975a1.658,1.658,0,0,0-1.658,1.658V34.9H13V29.925a4.99,4.99,0,0,1,4.975-4.975H39.533V15h3.317v9.95H64.407A4.99,4.99,0,0,1,69.382,29.925ZM13,58.116h3.317v6.633H13Zm53.066,0h3.317v6.633H66.066Z",
    transform: "translate(7.9 9.216)",
    fill: "#79818f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataStructure);
export default __webpack_public_path__ + "static/media/data-structure.4958c92db31b462c7f7a9c7abb0704d4.svg";
export { ForwardRef as ReactComponent };